function isLocalStorageDisabled() {
  try {
    const testKey = `test-key-${Math.random().toString()}`;

    window.localStorage.setItem(testKey, 'test');
    window.localStorage.removeItem(testKey);

    return false;
  } catch (err) {
    console.warn('Local storage is disabled.');
    return true;
  }
}

let storage = window.localStorage;

if (isLocalStorageDisabled()) {
  storage = {
    setItem(key, value) {
      if (arguments.length !== 2) {
        throw new TypeError(
          "Failed to execute 'setItem' on 'Storage': 2 arguments required, but only 1 present"
        );
      }
      document.cookie = `${key}=${value}`;
    },
    getItem(key) {
      const [, partAfterKey] = `; ${document.cookie}`.split(`; ${key}=`);
      return partAfterKey ? partAfterKey.split(';')[0] : null;
    },
    removeItem(key) {
      document.cookie = `${key}=;expires=Thu, 01 Jan 1970 00:00:01 GMT`;
    },
    clear() {
      const entries = document.cookie.split(';');

      entries.forEach((entry) => {
        const [key] = entry.split('=');
        this.removeItem(key);
      });
    },
  };
}

export default storage;



// WEBPACK FOOTER //
// ./src/storage/index.js